import { useEffect, useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";

type Mapping = {
  default: string;
  [path: string]: string; // path pattern -> icon url
};

function setFavicon(url: string) {
  document
    .querySelectorAll<HTMLLinkElement>(
      "link[rel~='icon'], link[rel='shortcut icon']"
    )
    .forEach((el) => el.parentNode?.removeChild(el));

  const link = document.createElement("link");
  link.rel = "icon";
  const bust = url.includes("?") ? `&v=${Date.now()}` : `?v=${Date.now()}`;
  link.href = url + bust;
  document.head.appendChild(link);

  const shortcut = document.createElement("link");
  shortcut.rel = "shortcut icon";
  shortcut.href = link.href;
  document.head.appendChild(shortcut);
}

export default function FaviconController({ mapping }: { mapping: Mapping }) {
  const { pathname } = useLocation();

  const iconUrl = useMemo(() => {
    // duyệt toàn bộ mapping, hỗ trợ pattern (/:idpage/videos)
    for (const [pattern, url] of Object.entries(mapping)) {
      if (pattern === "default") continue;
      if (matchPath({ path: pattern, end: true }, pathname)) {
        return url;
      }
    }
    return mapping.default;
  }, [pathname, mapping]);

  useEffect(() => {
    if (!iconUrl) return;
    setFavicon(iconUrl);
  }, [iconUrl]);

  return null;
}
